import { Config } from 'src/apis/config'
import { ActionTree } from 'vuex'
import { StateInterface } from '../index'
import { ConfigStateInterface } from './state'
import types from './types'

const actions: ActionTree<ConfigStateInterface, StateInterface> = {
  setConfig({ commit }, params: Config) {
    commit(types.SET_CONFIG, params)
  },
}

export default actions
